import { cn } from '@/lib/utils';
import { ratingLevel } from '@/lib/schema/loader';

/**
 * Colored tab strip 1–7. The computed score highlights the matching tab
 * (page 1 of the wireframe: "1" highlighted orange; page 2: "3"; page 3: "5").
 *
 * Scores 2/4/6 are transitional — they appear but are never "clickable" since
 * they emerge from the rubric, not from observer intent.
 */
export function LevelTabStrip({
  currentScore,
}: {
  currentScore: number | null;
}) {
  return (
    <div
      role="tablist"
      aria-label="Score levels"
      className="grid grid-cols-7 gap-1 px-6 pt-3"
    >
      {[1, 2, 3, 4, 5, 6, 7].map((lvl) => {
        const meta = ratingLevel(lvl);
        const active = currentScore === lvl;
        return (
          <div
            key={lvl}
            role="tab"
            aria-selected={active}
            data-level={lvl}
            className={cn(
              'relative flex min-h-[42px] items-center justify-center rounded-t-md border px-3 py-2 text-sm font-medium transition',
              active
                ? 'text-white shadow-md'
                : 'bg-muted/70 text-muted-foreground',
            )}
            style={
              active
                ? { backgroundColor: `var(--level-bg)`, borderColor: `var(--level-bg)` }
                : undefined
            }
          >
            {meta?.label ? `${meta.label} (${lvl})` : lvl}
          </div>
        );
      })}
    </div>
  );
}
